export default "__VITE_ASSET__0b50ecc7__$_?nuxt_component=async&nuxt_component_name=SvgoGoodFirm__"